import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { removeNotification, selectNotifications } from 'src/shared/slices/app-slice';

import { Notification } from '@alfalab/core-components/notification';
import { NotificationManager } from '@alfalab/core-components/notification-manager';

export const Notifications = () => {
    const dispatch = useDispatch();
    const notifications = useSelector(selectNotifications);

    const onRemoveNotification = (id: string) => {
        dispatch(removeNotification(id));
    };

    return (
        <NotificationManager
            notifications={notifications.map((notification) => (
                <Notification
                    badge={notification.badge}
                    title={notification.title}
                    autoCloseDelay={5000}
                    id={notification.id}
                    key={notification.id}
                    onCloseTimeout={() => {
                        onRemoveNotification(notification.id);
                    }}
                >
                    {notification.subTitle}
                </Notification>
            ))}
            onRemoveNotification={onRemoveNotification}
        />
    );
};
